import React, { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import PCFApproved from "./PCFApproved";
import { GeneratePCFList, StudentEventStatus } from "./PCFUI";
import { REQUEST_TARGET_MODULES } from "../../../../../Library/APIsTarget";
import { openToast } from "../../../../../Library/ToastPopUp";
import { GET_COURSE_VALIDATE_REQ } from "../../../../Student/Reregistration-New/Components/PCFHandler";
import LoadingBtn from "../../../../Widgets/LoadingBtn";
import { AlertNotif } from "../../../../../Library/AlertNotif";
import CourseOvering from "./FormOvering/CourseOvering";
import CourseCatalog from "./FormOvering/CourseCatalog";
import MyPCFSS from "./FormOvering/MyPCFSS";
import MyPCF from "./FormOvering/MyPCF";
import MyPCFRevisions from "./FormOvering/MyPCFRevisions";

var AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];
export default function PCF({ data, students, stdStatus }) {
  if (data.status && data.status === "PROCESSED") {
    return <PCFApproved data={data} />;
  } else {
    return (
      <AppvPCFForm data={data} students={students} stdStatus={stdStatus} />
    );
  }
}

const AppvPCFForm = ({ data, students, stdStatus }) => {
  const [totalsks, setTotalSKS] = useState(0);
  const [fPCF, setFPCF] = useState([]);
  const [cpl, setCPL] = useState({ loading: false, data: [], message: "" });
  const [courses, setCourses] = useState({
    loading: false,
    data: [],
    message: "",
  });
  const [originpcf, setOriginPCF] = useState([]);
  const [mypcf, setMypcf] = useState([]);
  const [selectedAcad, setSelectedAcad] = useState(0);
  const [acadActv, setAcadActv] = useState([]);

  const current_program_degree = students?.program?.id || 0;
  const current_cgpa = students?.cgpa || 0;
  const minGPABachelor = 2.1;
  const minGPAMaster = 3.1;
  const [has_thesis, setHasThesis] = useState("");

  const HandlerMessageThesisWithGPAUnderSpec = (thesis, program) => {
    let message = `The student is about to enroll in ${thesis.name} (${thesis.section_id}) with a current CGPA below ${program === 1 ? minGPABachelor : program === 2 ? minGPAMaster : ""}. 
                This situation may pose graduation risks, as the minimum required CGPA is ${program === 1 ? 2 : program === 2 ? 3 : 0}.00. Please guide the student to simulate the minimum GPA they need to achieve this semester and provide appropriate academic advice.`;

    return message;
  };

  const GET_COUNSELING_COURSE_STUDENT = async (param) => {
    setCPL({ loading: true, data: [], message: "" });
    const parameters = {
      parameters: param,
      target_data: "GET_COUNSELING_COURSE_STUDENT",
    };
    const results = await REQUEST_TARGET_MODULES(parameters);
    if (results.data && Object.values(results.data).length > 0) {
      const fpcf = results.data.filter((prev) => prev.in_semester === 1);
      if (fpcf) {
        const firstPCF = fpcf.map((f) => {
          let obj = {};
          obj.action_type = "original";
          obj.course_id = f.course_id;
          obj.origin = true;
          obj.section_id = f.section_id;
          obj.detail = f;
          obj.detail.course_credit = f.credit;
          let typeArr = f.course_type.split(".");
          let type = typeArr[typeArr.length - 1];
          obj.detail.course_type = type;
          return obj;
        });
        setFPCF(firstPCF);
      }

      const lastCourse = results.data.filter((prev) => prev.in_semester !== 1);
      setCPL({ loading: false, data: lastCourse, message: "" });
    } else {
      setCPL({
        data: [],
        loading: false,
        message: results.message || "No record found",
      });
    }
  };

  const GET_COUNSELING_PCF = async (param) => {
    setCourses({ loading: true, data: [], message: "" });
    const parameters = {
      parameters: param,
      target_data: "GET_COUNSELING_PCF",
    };
    const results = await REQUEST_TARGET_MODULES(parameters);
    if (results.data && Object.values(results.data).length > 0) {
      var FPCF = results.data.filter((prev) => prev.action_type);
      FPCF.sort((a, b) => a.semester - b.semester);
      setCourses({ ...courses, loading: false, data: results.data });
      if (Object.values(FPCF).length > 0) {
        let resObjOri = GeneratePCFList(FPCF);
        setOriginPCF(resObjOri);
        let resObj = GeneratePCFList(FPCF);
        setMypcf(resObj);
      } else {
        setCourses({ data: [], loading: false, message: "No record found" });
      }
    } else {
      setCourses({
        data: [],
        loading: false,
        message: results.message || "No record found",
      });
    }
  };

  const GET_ACTIVE_ACAD = async () => {
    setAcadActv({ loading: true, data: [], message: "" });
    const param = {
      target_data: "GET_ACTIVE_ACAD",
    };
    const results = await REQUEST_TARGET_MODULES(param);
    if (results.data && Object.values(results.data).length > 0) {
      const std_group = stdStatus.atp_group_type;
      const selected = results.data.find(
        (prev) => prev.atp_group_type.id === std_group,
      );
      if (selected) {
        setSelectedAcad(selected.reff_atp_id_term);
        setAcadActv({ message: "", loading: false, data: param });
      }
    } else {
      setAcadActv({
        data: [],
        loading: false,
        message: results.message || "No record found",
      });
    }
  };

  useEffect(() => {
    if (data.studentid && data.id) {
      GET_COUNSELING_COURSE_STUDENT({ studentid: data.studentid });
      GET_COUNSELING_PCF({ eventid: data.id });
    }
    GET_ACTIVE_ACAD();
  }, [data]);

  useEffect(() => {
    if (mypcf) {
      const is_thesis = mypcf.find(
        (item) => item.action_type === "add" && item.detail.is_thesis !== 0,
      );
      if (is_thesis && Object.values(is_thesis).length > 0) {
        const thesis = {
          name: is_thesis?.detail?.coursetitle || "",
          section_id: is_thesis?.section_id || "",
        };
        const message = HandlerMessageThesisWithGPAUnderSpec(
          thesis,
          current_program_degree,
        );

        if (
          (current_program_degree === 1 && current_cgpa < minGPABachelor) ||
          (current_program_degree === 2 && current_cgpa < minGPAMaster)
        ) {
          openToast({ header: "Information", message: message });
          setHasThesis(message);
        }
      }
    }
  }, [mypcf]);

  const handlerActionCourse = async (values) => {
    console.log(values);
    if (values.action_type === "add") {
      if (stdStatus.term_intake.id === selectedAcad) {
        const clonepcf = [...mypcf];
        clonepcf.push(values);
        setMypcf(clonepcf);
      } else {
        const result = await GET_COURSE_VALIDATE_REQ({
          clu_id: stdStatus?.clu?.id || 0,
          clu_spec_id: stdStatus?.clu_spec?.id || 0,
          course_id: values.course_id,
          studentid: stdStatus.studentid,
        });
        if (result.data === 1) {
          //check existing course
          // var isSame = mypcf.filter((prev) => (prev.section_id === values.section_id || prev.detail.course_code === values.detail.course_code));
          let isSame = mypcf.filter(
            (prev) =>
              (prev.section_id === values.section_id ||
                prev.detail.course_code === values.detail.course_code) &&
              (!prev.action_type || prev.action_type !== "remove"),
          );

          if (Object.values(isSame).length > 0) {
            const hasDifferentActionType = mypcf.some(
              (item) =>
                (item.course_id === values.course_id ||
                  item.section_id === values.section_id) &&
                item.action_type !== "add",
            );
            if (hasDifferentActionType) {
              const clonepcf = [...mypcf];
              clonepcf.push(values);
              setMypcf(clonepcf);
            } else {
              openToast({
                header: "Information",
                message: "This course has already been added to the 'PCF'",
              });
            }
          } else {
            const clonepcf = [...mypcf];
            clonepcf.push(values);
            setMypcf(clonepcf);
          }
        } else {
          openToast({
            header: "Information",
            message: "Course is not eligible for selection",
          });
        }
      }
    } else if (values.action_type === "remove") {
      var clone = [...mypcf];
      clone.splice(values.index, 1);
      setMypcf(clone);
    } else {
      alert("Failed execute no action type");
    }
  };

  return (
    <>
      <div className="card card-custom gutter-b mb-8">
        <div className="card-body pb-0">
          <StudentEventStatus data={data} />
        </div>
      </div>

      {has_thesis && (
        <div className="alert mb-5" style={{ backgroundColor: "#890e25" }}>
          <div className="alert-title text-left">
            <div className="d-flex align-items-center">
              <i className="icon-2x text-white flaticon-warning-sign mr-5"></i>
              <span className="text-white font-size-h4">
                {has_thesis}
                {/* The student is about to enroll in [Thesis course name] with a current CGPA below 2.10. This situation may pose graduation risks, as the minimum required CGPA is 2.00. Please guide the student to simulate the minimum GPA they need to achieve this semester and provide appropriate academic advice. */}
              </span>
            </div>
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-4">
          <CourseOvering
            data={cpl.data}
            student={students.data}
            studentid={data.studentid}
            curriculum={stdStatus?.curr || ""}
            stdStatus={stdStatus}
          />
        </div>

        <div className="col-4">
          {selectedAcad && (
            <CourseCatalog
              handlerActionCourse={handlerActionCourse}
              student={students.data}
              selectedAcad={selectedAcad}
            />
          )}
        </div>

        <div className="col-4">
          {courses.loading ? (
            <LoadingBtn />
          ) : courses.message ? (
            <AlertNotif message={courses.message} color={"danger"} />
          ) : (
            Object.values(courses.data).length > 0 && (
              <>
                {data.student_activity.id === "asc.student.activity.pcfr" && (
                  <MyPCFRevisions
                    fPCF={fPCF}
                    originPCFRev={originpcf}
                    mypcf={mypcf}
                    setMypcf={setMypcf}
                    eventid={data.id}
                    student={students.data}
                    stdStatus={stdStatus}
                    studentid={data.studentid}
                    acad={data.atp_term}
                    totalsks={totalsks}
                    setTotalSKS={setTotalSKS}
                    selectedAcad={selectedAcad}
                  />
                )}
                {/* data.student_activity.id === "asc.student.activity.shortsemester" */}
                {(data?.atp_term &&
                data?.atp_term?.name.includes("Short") &&
                data.student_activity.id === "asc.student.activity.pcf") ? (
                  <MyPCFSS
                    fPCF={fPCF}
                    mypcf={mypcf}
                    setMypcf={setMypcf}
                    eventid={data.id}
                    student={students.data}
                    stdStatus={stdStatus}
                    studentid={data.studentid}
                    acad={data.atp_term}
                    totalsks={totalsks}
                    setTotalSKS={setTotalSKS}
                    selectedAcad={selectedAcad}
                  />
                ) : (
                  <MyPCF
                    fPCF={fPCF}
                    mypcf={mypcf}
                    setMypcf={setMypcf}
                    eventid={data.id}
                    student={students.data}
                    stdStatus={stdStatus}
                    studentid={data.studentid}
                    acad={data.atp_term}
                    totalsks={totalsks}
                    setTotalSKS={setTotalSKS}
                    selectedAcad={selectedAcad}
                  />
                )}
              </>
            )
          )}
        </div>
      </div>
    </>
  );
};
